module.exports = __webpack_public_path__ + "static/media/banglore to hyderabad.df59b4fa.jpg";